import React, { useState, useEffect } from "react";
import { Breadcrumb, Button, Card, Row, Col, NavLink, CardHeader, CardBody, Tab } from "react-bootstrap";
import { AiFillHdd } from "react-icons/ai";
import { Link } from "react-router-dom";
import { fetch } from "../../utils";
import { compose, current } from "@reduxjs/toolkit";
import { Line } from "react-chartjs-2";
import { CategoryScale } from "chart.js";
import Chart from "chart.js/auto";

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling

// Chart.register(CategoryScale);

import { Pie } from 'react-chartjs-2';


const AdminDashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [orderStatus, setOrderStatus] = useState([]);
  const [donationAMT, setDonationAMT] = useState([]);

  const getOrdersDetails = async () => {
    try {
      setIsLoading(true);
      const response = await fetch('order/all', 'Post', null, null);
      const orders = response.data.data.orders;
      setOrderStatus(orders);
    } catch (error) {
      setIsLoading(false);
    }
  };


  console.log('orderStatus', orderStatus)

  const donationAmount = async () => {
    try {
      setIsLoading(true);
      const response = await fetch('donation/donation-list', 'get', null, null);
      const donation = response.data.data.donationList;
      setDonationAMT(donation);
      console.log('res', response.data.data.donationList)
    } catch (error) {
      setIsLoading(false);
    }
  };

  const totalDonation = donationAMT.filter(donation => donation.donation_status_name === "Confirmed");


  const totalDonationAmount = totalDonation.map(item => parseFloat(item.donation_amount));
  const totalDonationRevenue = totalDonationAmount.reduce((total, amount) => total + parseFloat(amount), 0) || 0;

  const calendarEvents = orderStatus.map(booking => {
    return {
      id: booking.cust_order_id,
      title: `${booking.customer_fname}  ${booking.customer_lname}`,
      start: new Date(booking.order_datetime).toISOString().split('T')[0],
      mobile: `${booking.customer_mobile},  ${booking.customer_email}`,
      amt: `${booking.order_amount}`,
      status: `${booking.order_status_name}`,
      url: `/admin/order/${booking.cust_order_id}/${booking.cust_order_id}`
    };
  });

  useEffect(() => {
    getOrdersDetails();
    donationAmount();
  }, []);




  const todayOrder = new Date().toISOString().split('T')[0];
  const currentDayOrders = orderStatus.filter(order => order.order_datetime.startsWith(todayOrder));
  const initiatedOrders = orderStatus.filter(order => order.order_status_name === "Initiated");
  const confirmedOrders = orderStatus.filter(order => order.order_status_name === "Confirmed");
  const cancelledOrders = orderStatus.filter(order => order.order_status_name === "Cancelled");
  const dispatchOrders = orderStatus.filter(order => order.order_status_name === "Dispatched");
  const diliveredOrders = orderStatus.filter(order => order.order_status_name === "Delivered");
  const mismatchOrders = orderStatus.filter(order => order.order_status_name === "Amount Mismatch");

  const orderAmounts = confirmedOrders.map(item => parseFloat(item.order_amount));
  const totalRevenue = orderAmounts.reduce((total, amount) => total + parseFloat(amount), 0) || 0;

  const orderCountsByDate = confirmedOrders.reduce((accumulator, order) => {
    const date = order.order_datetime.split('T')[0];
    accumulator[date] = (accumulator[date] || 0) + 1;
    return accumulator;
  }, {});


  const orderCounts = {
    Confirmed: orderStatus.filter(order => order.order_status_name === "Confirmed").length,
    Initiated: orderStatus.filter(order => order.order_status_name === "Initiated").length,
    Cancelled: orderStatus.filter(order => order.order_status_name === "Cancelled").length,
    Dispatched: orderStatus.filter(order => order.order_status_name === "Dispatched").length,
    Delivered: orderStatus.filter(order => order.order_status_name === "Delivered").length,
    "Amount Mismatch": orderStatus.filter(order => order.order_status_name === "Amount Mismatch").length
  };
  const labels = Object.keys(orderCounts);
  const data = Object.values(orderCounts);
  const chartData = {
    labels: labels,
    datasets: [
      {
        data: data,
        backgroundColor: [

          // 'rgba(54, 162, 235, 0.6)',
          'rgba(13, 110, 235, 0.8)',
          'rgba(255, 193, 7, 0.8)',
          'rgba(220, 53, 69, 0.8)',
          'rgba(25, 135, 84, 0.8)',
          'rgba(170, 26, 195, 0.8)',
          'rgba(255, 159, 64, 0.6)'
        ],
      }
    ]
  };

  // Chart.js options
  const legendPosition: 'top' | 'left' | 'bottom' | 'right' = 'right';

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        left: 0,
        right: 0,
      },
    },
    plugins: {
      legend: {
        position: legendPosition,
      },
    },
  };



  const orderCountsByMonth = confirmedOrders.reduce((accumulator, order) => {
    const date = new Date(order.order_datetime);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // ensures two digits
    const yearMonth = `${year}-${month}`; // e.g., "2024-01"

    accumulator[yearMonth] = (accumulator[yearMonth] || 0) + 1;
    return accumulator;
  }, {});


  const chartData2 = {
    labels: Object.keys(orderCountsByMonth).map(monthYear => {
      const [year, month] = monthYear.split('-');
      return `${new Date(year, month - 1).toLocaleString('default', { month: 'short' })} ${year}`;
    }),
    datasets: [
      {
        label: 'Monthly Orders',
        data: Object.values(orderCountsByMonth),
        fill: false,
        borderColor: 'rgb(13, 110, 253)',
        tension: 0.1,
      },
    ],
  };

  const options2 = {
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
        },
      }
    },
  };


  // const chartData2 = {
  //   labels: Object.keys(orderCountsByDate),
  //   datasets: [
  //     {
  //       label: 'Number of Orders',
  //       data: Object.values(orderCountsByDate),
  //       fill: false,
  //       borderColor: 'rgb(75, 192, 192)',
  //       tension: 0.1,
  //     },
  //   ],
  // };



  return (
    <div className="container-fluid pb-5" style={{
      backgroundColor: "#eaeff8"
    }}>
      <Breadcrumb className="p-2">
        <Breadcrumb.Item href="#">Home</Breadcrumb.Item>

        <Breadcrumb.Item active>Dashboard</Breadcrumb.Item>
      </Breadcrumb>

      <section className="content">
        <div className="container-fluid">



          {/* <Card.Header>
                  <h4>
                    Dashboard{" "}
                  </h4>
                </Card.Header> */}

          <Row sm={1} lg={5} xs={1}>
            {/* <Row className='py-1'> */}
            <Col className="mb-2">
              <Link to='/admin/2/orders'>
                <div className="small-box admin-box text-white bg-info">

                  <div className="inner ">
                    <h2><strong>{currentDayOrders.length}</strong></h2>
                    <p className="mb-0">Today's Order</p>
                  </div>


                  {/* <Link to='/admin/2/orders' className="small-box-footer text-white bg-info">More info <i className="fa fa-arrow-circle-right" aria-hidden="true">
                  </i></Link>  */}
                </div>

              </Link>
            </Col>
            <Col className="my-1">
              <Link to='/admin/2/orders'>
                <div className="small-box admin-box  text-white bg-primary">
                  <div className="inner ">
                    <h2><strong>{confirmedOrders.length}</strong></h2>
                    <p className="mb-0">Confirmed Orders</p>
                  </div>
                  {/* <Link to='/admin/2/orders' className="small-box-footer text-white bg-primary">More info <i className="fa fa-arrow-circle-right" aria-hidden="true"></i></Link> */}
                </div>
              </Link>
            </Col>
            <Col className="my-1">
              <Link to='/admin/1/orders'>
                <div className="small-box admin-box  text-white bg-warning">
                  <div className="inner ">
                    <h2><strong>{initiatedOrders.length}</strong></h2>
                    <p className="mb-0">Initiated Order</p>
                  </div>
                  {/* <Link to='/admin/1/orders' className="small-box-footer text-white bg-warning">More info <i className="fa fa-arrow-circle-right" aria-hidden="true"></i></Link> */}
                </div>
              </Link>
            </Col>
            <Col className="my-1">
              <Link to="/admin/4/orders">
                <div className="small-box admin-box text-white bg-success">
                  <div className="inner ">
                    <h2><strong>{dispatchOrders.length}</strong></h2>
                    <p className="mb-0">Dispatch Order</p>
                  </div>
                  {/* <Link to="/admin/4/orders" className="small-box-footer text-white bg-success">More info <i className="fa fa-arrow-circle-right" aria-hidden="true"></i></Link> */}
                </div>
              </Link>
            </Col>

            <Col className="my-1">
              <Link to='/admin/3/orders'>
                <div className="small-box admin-box  text-white bg-danger">
                  <div className="inner ">
                    <h2><strong>{cancelledOrders.length}</strong></h2>
                    <p className="mb-0">Cancelled Order</p>
                  </div>
                  {/* <Link to='/admin/3/orders' className="small-box-footer text-white bg-danger">More info <i className="fa fa-arrow-circle-right" aria-hidden="true"></i></Link> */}
                </div>
              </Link>
            </Col>
          </Row>






          <Row className="my-3">
            <Col sm={6}>
              <Card style={{ padding: "8px 15px" }}>
                <Line data={chartData2} options={options2} />
              </Card>
            </Col>
            <Col sm={4}>
              <Card style={{ padding: "65px 0" }}>
                <Pie data={chartData} options={chartOptions} /> </Card>
            </Col>

            <Col sm={2}>
              <Card>
                <div className=" pt-2 px-2">
                  <h6 className="m-0"><b>Total  Revenue</b></h6>
                  <h4 className="m-0 text-success"> <b>Rs. {totalRevenue.toFixed(2)}</b> </h4>
                </div>
                <img decoding="async" loading="lazy" src={require('../assets/line.png')} alt="img" rel="preload" style={{ height: "60px" }}
                  as="image" className="d-block w-100 slider-img" />              </Card>


              <Card className="mt-2">
                <div className=" pt-2 px-2">
                  <h6 className="m-0"><b>Total Donation</b></h6>
                  <h4 className="m-0" style={{ color: "#3F51B5" }}> <b>Rs. {totalDonationRevenue.toFixed(2)}</b> </h4>
                </div>
                <img decoding="async" loading="lazy" src={require('../assets/donat.png')} style={{ height: "60px" }} alt="img" rel="preload"
                  as="image" className="d-block w-100 slider-img" />              </Card>


              <Card className="mt-2">
                <div className=" py-3 px-2">
                  <img decoding="async" loading="lazy" src={require('../assets/circle.png')} style={{ height: "75px" }} alt="img" rel="preload"
                    as="image" className="d-block  slider-img count-img" />
                  <h6 className="m-0 pt-2"><b>Visitor</b></h6>
                  <h5 className="m-0" style={{ color: "#177ca1" }}> <b>100</b> </h5>
                </div>








              </Card>

            </Col>




          </Row>


          <Row>
            <Col sm={5} className="p-0">
              <Card >
                <CardBody>
                  <div className="col-sm-12 calendar-container">
                    <FullCalendar
                      plugins={[dayGridPlugin]}
                      initialView='dayGridMonth'
                      editable={true}
                      selectable={true}
                      selectMirror={true}
                      dayMaxEvents={true}
                      weekends={true}
                      events={calendarEvents}
                      eventDidMount={function (info) {
                        tippy(info.el, {
                          content: ` ${info.event.title}<br />
                     ${info.event.extendedProps.mobile}<br /> 
                    Amt : ${info.event.extendedProps.amt}<br />                   
                          `,
                          allowHTML: true,
                          arrow: true
                        });
                      }}
                    />
                  </div>

                </CardBody>
              </Card>
            </Col>
            <Col sm={7}>
              <Card >
                <CardBody>
                  <h5> Latest Orders </h5>
                  <table className="table table-dark dash-table">
                    <thead style={{   lineHeight: "13px"}}>
                      <tr style={{ background: "#a7a7a7" }}>

                        <th scope="col">Customer</th>
                        <th scope="col">Amount</th>
                        <th scope="col">status</th>
                        <th scope="col">Loaction</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody className="text-dark">
                     

                      {orderStatus.length > 0 ? (
                        orderStatus
                          .slice(0, 5) 
                          .sort((a, b) => b.cust_order_id - a.cust_order_id) 
                          .map((orderlist, i) => (
                            <tr key={i}>

                              <td className="text-dark">{orderlist.customer_fname} {orderlist.customer_lname}</td>
                              <td className="text-dark">{orderlist.order_amount}</td>
                              <td>
                                <font size='1' className="text-white px-2 rounded-2" style={{
                                  backgroundColor: (() => {
                                    switch (orderlist.order_status_name) {
                                      case 'Confirmed':
                                        return 'green';
                                      case 'Initiated':
                                        return 'blue';
                                      case 'Cancelled':
                                        return 'red';
                                      default:
                                        return 'red';
                                    }
                                  })()
                                }}>{orderlist.order_status_name}</font>
                              </td>
                              <td style={{ textTransform: 'lowercase' }} className="text-dark">{orderlist.ship_city}, {orderlist.ship_state}</td>
                              <td>

                                <Link
                                  to={`/admin/order/${orderlist.cust_order_id}/${orderlist.cust_order_id}`}
                                >View</Link>
                              </td>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center pt-5">No data found</td>
                        </tr>
                      )}



                    </tbody>
                  </table>
                </CardBody>
              </Card>


              {/* <div className="mt-2">
                <Card >
      
                  <CardBody>
                    <h5> Latest Orders  Donation</h5>
                    <table className="table table-dark dash-table">
                      <thead>
                        <tr style={{ background: "#a7a7a7" }}>

                          <th scope="col">Customer</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Address</th>
                          <th scope="col">status</th>
                   
                       
                        </tr>
                      </thead>
                      <tbody className="text-dark">
                        {donationAMT.length > 0 ? (
                          donationAMT
                            .slice(0, 3) // Assuming you want to display only the first 5 orders
                            .sort((a, b) => b.donation_id - a.donation_id) // Sort by descending cust_order_id
                            .map((donationlist, i) => (
                              <tr key={i}>

                                <td>{donationlist.fname} {donationlist.lname}</td>
                                <td>{donationlist.donation_amount}</td>
                                <td style={{ textTransform: 'lowercase' }}>{donationlist.adderss}</td>
                                <td>
                                  <font size='1' className="text-white px-2 rounded-2" style={{
                                    backgroundColor: (() => {
                                      switch (donationlist.donation_status_name) {
                                        case 'Confirmed':
                                          return 'green';
                                        case 'Initiated':
                                          return 'blue';
                                        case 'Cancelled':
                                          return 'red';
                                        default:
                                          return 'red';
                                      }
                                    })()
                                  }}>{donationlist.donation_status_name}</font>
                                </td>
                             
                              
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center pt-5">No data found</td>
                          </tr>
                        )}



                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div> */}
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default AdminDashboard;
